import { render, staticRenderFns } from "./questionnaireList.vue?vue&type=template&id=8372912a&"
import script from "./questionnaireList.vue?vue&type=script&lang=js&"
export * from "./questionnaireList.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports